import * as React from 'react';
import Big, { BigConstructor } from 'big.js';
import ITradePricing from './ITradePricing';
import { noLeadingZeros } from '@market/features/helpers/functions';
import { numberWithDelimiter } from '@features/utils/functions';
import { CurrencyUpper } from '@market/features/const.market';
import { max4Decimal } from '../../../../regexps';

import * as style from './TradePricingStyle.module.scss'

export default class TradePricing extends React.Component<ITradePricing> {

  private big: BigConstructor = Big();

  onChange = (e: React.ChangeEvent<any>) => {
    const value = e.target.value;
    const valueAsNumber = Number(value) || 0;

    if (this.big(valueAsNumber).gte(0)
      && this.big(valueAsNumber).lte(this.props.orderSharesAmount)
      && max4Decimal.test(value.toString())) {

      this.props.updateState({
        numberOfSharesInput: value,
        convertShares: false,
        totalValue: this.big(valueAsNumber).times(this.props.pricePerShare).toFixed(4),
      });
    }
  }

  setMax = () => {
    this.props.updateState({
      numberOfSharesInput: this.props.orderSharesAmount,
      totalValue: this.big(this.props.orderSharesAmount)
        .times(this.props.pricePerShare).toFixed(4),
    });
  }

  render() {
    return (
        <div className={style.tradePricing}>
          <div>
            <p>No. of Shares</p>
            <input
              onChange={this.onChange}
              value={this.props.numberOfSharesInput || ''}
              placeholder="Enter Amount"
              step="any"
              data-cy="number-of-shares"
            />
            {!this.big(Number(this.props.numberOfSharesInput) || 0).eq(this.props.orderSharesAmount) &&
              (
                <span className={style.max} onClick={this.setMax}>
                  {this.props.fillOrderButton
                    ? `Fill whole order (${numberWithDelimiter(this.props.orderSharesAmount)})`
                    : `Sell all available shares (${numberWithDelimiter(this.props.orderSharesAmount)})`
                  }
                </span>
              )
            }
          </div>
          <div>
            <p>Price per share ({CurrencyUpper})</p>
            <p data-cy="price-per-share">{numberWithDelimiter(this.props.pricePerShare)}</p>
          </div>
          <div>
            <p>Total ({CurrencyUpper})</p>
            <p data-cy="total">{numberWithDelimiter(noLeadingZeros(this.props.totalOrderValue))}</p>
          </div>
        </div>
    );
  }
}
